module.exports = __webpack_public_path__ + "img/Calendar_Flatline.efc7bda2.svg";